import { useEffect, useRef, useState } from "react";
import { YHDrawer } from "@/components/YhDrawer";
import { useLibraryModel } from "../libraryModel";
import { YhForm } from "@/components/YhFormBox";
import { IYhForm, IYhFormRef, FormItemTypeEnum } from "@/components/YhFormBox/Types";
import { ILibraryDetial } from "../libraryTypes";
import { message } from "antd";
import { getFormValidatorErrText } from "@/utils/utils";
import { useDictModel } from "@/views/dict/dictModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { FoodCategory, IFoodCategoryOotions } from "@/types/AppEnums";
import { libraryService } from "../libraryService";
import { userService } from "@/views/user/userService";
import { ISelectOptions } from "@/types/AppTypes";

export function DetailDrawer() {
    const { dataRestaurantSource } = useGlobalModel()
    const {
        visibleDrawer: { visible, mode },
        selectedRow,
        setIVisibleDrawer,
        insertDetail,
        editDetail,
        md5FormVal, setMd5FormVal
    } = useLibraryModel()
    const { getSelectedDictOne } = useDictModel()
    const [isHide, setIsHide] = useState<boolean>(false);
    const [data, setData] = useState<ILibraryDetial[]>([]);

    const formRef = useRef<IYhFormRef>();
    const [chefList, setChefList] = useState<ISelectOptions[]>([]);
    useEffect(() => {
        if (visible) {
            loadData()
            if (mode === "edit") {
                setIsHide(selectedRow.category === FoodCategory.material);
                formRef.current?.setFieldsValue({
                    ...selectedRow,
                    canteens: selectedRow?.canteens?.map(item => item.id),
                    labelCode: selectedRow?.labelCode?.split(','),
                    cooks: selectedRow?.cooks?.map((item: { id: any; }) => item.id),
                })
            } else {
                formRef.current?.setFieldsValue({})
            }
        }
    }, [visible])

    const loadData = async () => {
        const searchParams = {
            material: 1,
            page: {
                pageSize: 10000,
                pageNum: 1,
            }
        }
        let { retData } = await libraryService.page(searchParams);
        let { data, ...pg } = retData;
        setData(data);
        let { retData: chefData } = await userService.page({
            type: "1",
            page: {
                pageSize: 10000,
                pageNum: 1,
            }
        });
        setChefList((chefData.data ?? []).map(item => ({
            label: item.name ?? "",
            value: item.id ?? ""
        })))
    }

    const onCancel = () => {
        setIVisibleDrawer()
        setMd5FormVal([])
    }

    const onSubmit = () => {
        formRef.current?.validateFields().then((val: any) => {
            if (!md5FormVal.length) {
                message.warning("菜品图片为必填项");
                return;
            }
            let newVal = {
                ...val,
                // materialType: isHide ? "" : val.materialType ? val.materialType.join() : "",
                price: isHide ? undefined : val.price
            }
            mode === "edit" ? editDetail(newVal) : insertDetail(newVal)
        }).catch(err => {
            message.warning(getFormValidatorErrText(err));
        })
    }
    const onSetFieldsValue = (formValues: { [key: string]: any }, isFormItem: boolean = true) => {
        setMd5FormVal(formValues.image)
    }

    const categoryChange = (value: string) => {
        setIsHide(value === FoodCategory.material)
    }
    const formConfig: IYhForm<ILibraryDetial> = {
        formRef,
        labelCol: { span: 6 },
        // onChange,
        // formValues: mode === "edit" ? {} : {},
        items: [
            {
                type: FormItemTypeEnum.Input,
                span: 24,
                fieldLabel: "菜品名称",
                fieldName: "name",
                rules: [{ required: true, message: "请输入菜品名称" }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "菜品分类",
                fieldName: "category",
                span: 24,
                options: IFoodCategoryOotions,
                onSelectChange: categoryChange,
                rules: [{ required: true, message: "请输入菜品分类" }]
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "菜品标签",
                fieldName: "labelCode",
                span: 24,
                selectMode: "multiple",
                options: getSelectedDictOne(DictCodeEnmu.CAIPINBIAOQIAN)
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "餐厅名称",
                fieldName: "canteens",
                span: 24,
                selectMode: "multiple",
                options: transOptions(dataRestaurantSource),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "菜品价格",
                fieldName: "price",
                span: 24,
                // rules: [{ required: !isHide, message: "请输入菜品分类" }, { pattern: /^[0-9]+(.[0-9]{0,2})?$/, message: '请输入数字且可保留两位小数' }],
                rules: [{ pattern: /^[0-9]+(.[0-9]{0,2})?$/, message: '请输入数字且可保留两位小数' }],
                hidden: isHide
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "厨师",
                fieldName: "cooks",
                span: 24,
                selectMode: "multiple",
                options: chefList,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: "原材料",
                fieldName: "materialType",
                span: 24,
                // selectMode: "multiple",
                options: transOptions(data),
                hidden: isHide
            },
            {
                type: FormItemTypeEnum.FileImage,
                fieldLabel: "上传图片",
                fieldName: "image",
                isOne: true,
                span: 24,
                md5List: md5FormVal,
                onSetFieldsValue,
                rules: [{ required: true, message: "该项为必填项" }]
            },
        ]
    }
    return (
        <YHDrawer
            {...{
                title: `菜品管理${mode === "add" ? '新增' : '编辑'}`,
                visible,
                onCancel,
                okText: "保存",
                onOk: onSubmit
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}